exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* hides the tickbox on the inputs */\ninput[type=checkbox] {\n    display: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/landingpages/dormantfeedback/dormantfeedback.component.css
// module id = 1019
// module chunks = 23